import { FormattedMessage, FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import TimedOrCategorySearchCard from '@/components/GridItemCard/Card/MultiCardOptions/TimedOrCategorySearchCard/TimedOrCategorySearchCard';
import FluidItemGrid from '@/components/GridItemCard/FluidItemGrid/FluidItemGrid';
import PageTitle from '@/components/PageTitle/PageTitle';
import { useAppSelector } from '@/redux/hooks';
import { getSortedRecommendedItemIdsFromState } from '@/redux/modules/recommendedItem';
import { getRecommendedSimilarItemIdsFromState } from '@/redux/modules/recommendedSimilarItems';
import { useReplaceRecommendedItemsWithSimilarLots } from '@/utils/amplitude/experiments/hooks/useReplaceRecommendedItemsWithSimilarLots';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import RecommendedItemPageHeaderMeta from './RecommendedItemPageHeaderMeta';

const RecommendedItemPage = () => {
    const { hasLastTwoSavedLots, hasLastTwoViewedLots } = useReplaceRecommendedItemsWithSimilarLots();
    const shouldUseRecommendedSimilarItems = hasLastTwoViewedLots || hasLastTwoSavedLots;
    const recommendedItemIds = useAppSelector((state) => getSortedRecommendedItemIdsFromState(state, 0));
    const recommendedSimilarItemIds = useAppSelector((state) => getRecommendedSimilarItemIdsFromState(state, 0));
    const itemIds = shouldUseRecommendedSimilarItems ? recommendedSimilarItemIds : recommendedItemIds;
    const formatMessageWithValues = useAppFormatMessage();

    return (
        <EnsureLoggedInContainer>
            <section
                className="relative mx-auto flex min-h-[400px] max-w-[1240px] flex-col pb-xl pr-md"
                id="recommendedItems"
            >
                <RecommendedItemPageHeaderMeta />
                <div className="[ mb-md flex flex-row flex-wrap items-baseline [@media(max-width:416px)]:flex-col [@media(max-width:416px)]:items-center [@media(max-width:416px)]:text-center">
                    <PageTitle title={<FormattedMessage id="recommended_items" />} />
                    <BodySecondary
                        className="ml-xs"
                        color="secondary"
                    >
                        {formatMessageWithValues(['search_item_count_items'], {
                            values: {
                                count: (
                                    <FormattedNumber
                                        key="recommended-item-page-results-count"
                                        style="decimal"
                                        value={itemIds.length}
                                    />
                                ),
                            },
                        })}
                    </BodySecondary>
                </div>
                <FluidItemGrid
                    itemCardOption={TimedOrCategorySearchCard}
                    itemIds={itemIds}
                />
            </section>
        </EnsureLoggedInContainer>
    );
};

export default RecommendedItemPage;
